<template>
    <section class="section use-case">
        <div class="container">
            <div class="row items-gap">
                <div class="col-12 col-sm-6 col-xl-3">
                    <div class="use-case__item wow fadeInUp" data-wow-duration="600ms" data-wow-delay="300ms">
                        <div class="thumb">
                            <img :src="require('@/assets/images/use-case/one.png')" alt="Image">
                        </div>
                        <div class="content">
                            <h5 class="h5">
                                <router-link to="/use-case-details"> Website Copy & SEO</router-link>
                            </h5>
                            <p>
                                The advanced AI technology makes our background eraser tool
                                easy to use. The image.
                            </p>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-sm-6 col-xl-3">
                    <div class="use-case__item wow fadeInUp" data-wow-duration="600ms" data-wow-delay="300ms">
                        <div class="thumb">
                            <img :src="require('@/assets/images/use-case/two.png')" alt="Image">
                        </div>
                        <div class="content">
                            <h5 class="h5">
                                <router-link to="/use-case-details">Social Media & Ads</router-link>
                            </h5>
                            <p>
                                The advanced AI technology makes our background eraser tool
                                easy to use. The image.
                            </p>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-sm-6 col-xl-3">
                    <div class="use-case__item wow fadeInUp" data-wow-duration="600ms" data-wow-delay="300ms">
                        <div class="thumb">
                            <img :src="require('@/assets/images/use-case/three.png')" alt="Image">
                        </div>
                        <div class="content">
                            <h5 class="h5">
                                <router-link to="/use-case-details">Blog Section Writing</router-link>
                            </h5>
                            <p>
                                The advanced AI technology makes our background eraser tool
                                easy to use. The image.
                            </p>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-sm-6 col-xl-3">
                    <div class="use-case__item wow fadeInUp" data-wow-duration="600ms" data-wow-delay="300ms">
                        <div class="thumb">
                            <img :src="require('@/assets/images/use-case/four.png')" alt="Image">
                        </div>
                        <div class="content">
                            <h5 class="h5">
                                <router-link to="/use-case-details">eCommerce Copy</router-link>
                            </h5>
                            <p>
                                The advanced AI technology makes our background eraser tool
                                easy to use. The image.
                            </p>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-sm-6 col-xl-3">
                    <div class="use-case__item wow fadeInUp" data-wow-duration="600ms" data-wow-delay="300ms">
                        <div class="thumb">
                            <img :src="require('@/assets/images/use-case/five.png')" alt="Image">
                        </div>
                        <div class="content">
                            <h5 class="h5">
                                <router-link to="/use-case-details">Digital Ad Copy</router-link>
                            </h5>
                            <p>
                                The advanced AI technology makes our background eraser tool
                                easy to use. The image.
                            </p>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-sm-6 col-xl-3">
                    <div class="use-case__item wow fadeInUp" data-wow-duration="600ms" data-wow-delay="300ms">
                        <div class="thumb">
                            <img :src="require('@/assets/images/use-case/six.png')" alt="Image">
                        </div>
                        <div class="content">
                            <h5 class="h5">
                                <router-link to="/use-case-details">Job Description</router-link>
                            </h5>
                            <p>
                                The advanced AI technology makes our background eraser tool
                                easy to use. The image.
                            </p>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-sm-6 col-xl-3">
                    <div class="use-case__item wow fadeInUp" data-wow-duration="600ms" data-wow-delay="300ms">
                        <div class="thumb">
                            <img :src="require('@/assets/images/use-case/seven.png')" alt="Image">
                        </div>
                        <div class="content">
                            <h5 class="h5">
                                <router-link to="/use-case-details">Testimonial & Review</router-link>
                            </h5>
                            <p>
                                The advanced AI technology makes our background eraser tool
                                easy to use. The image.
                            </p>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-sm-6 col-xl-3">
                    <div class="use-case__item wow fadeInUp" data-wow-duration="600ms" data-wow-delay="300ms">
                        <div class="thumb">
                            <img :src="require('@/assets/images/use-case/eight.png')" alt="Image">
                        </div>
                        <div class="content">
                            <h5 class="h5">
                                <router-link to="/use-case-details">Keywords Generator</router-link>
                            </h5>
                            <p>
                                The advanced AI technology makes our background eraser tool
                                easy to use. The image.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        name: "Cases",
    }
</script>


// WEBPACK FOOTER //
// src/components/page_components/use-case/Cases.vue